export default __webpack_public_path__ + "static/media/raven.5cd294e7.png";